// mutations.js
export default {
  SET_OPEN_DROPDOWN(state, id) {
    state.openDropdownId = id;
  },
};
